import {
	Component,
	EventEmitter,
	Input,
	Output,
	OnChanges,
} from '@angular/core';
import { NgForm } from '@angular/forms';
import LogRocket from 'logrocket';
import { TeranetService } from '@services/teranet/teranet.service';
import { MatterLRO } from '@models/matter';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { ICON } from '@core/util/icon';
import { openCloseWithState } from '@core/animations/animations';
import { SnackbarService } from '@services/ui/snackbar.service';
import { TestHooks } from './search-by-instrument.hooks';
import { firstValueFrom } from 'rxjs';
import { PinsResult } from '@models/teranet';

@Component({
	selector: 'app-teranet-search-by-instrument',
	templateUrl: './search-by-instrument.component.html',
	animations: [openCloseWithState()],
	standalone: false,
})
export class SearchByInstrumentComponent implements OnChanges {
	testHooks = TestHooks;
	public instrumentId: string;
	public pins: PinsResult;
	public searchingPins: boolean;
	public error: string;
	public submitted = false;
	public showSearchSection = true;

	public ICON = ICON;

	@Input() isOverview = false;
	@Input() showSearch = true;
	@Output() searchCompletedEvent = new EventEmitter<boolean>();

	@SelectSnapshot(SelectedMatter.LRO) lro: MatterLRO;
	@SelectSnapshot(SelectedMatter.id) saleId: string;

	constructor(
		private teranetService: TeranetService,
		private snackbar: SnackbarService,
	) {}

	ngOnChanges() {
		this.showSearchSection = this.showSearch;
	}

	async searchByInstrument(form: NgForm) {
		this.error = null;
		this.submitted = true;

		if (form.valid) {
			this.searchingPins = true;
			try {
				this.pins = await firstValueFrom(
					this.teranetService.searchByInstrument({
						lro: this.lro.selected.id,
						instrument_number: this.instrumentId.trim(),
					}),
				);
				this.searchCompleted(true);
			} catch (err) {
				LogRocket.log('Unable to search PIN', err);
				let friendlyError: string;
				if (!this.lro.selected?.id) {
					this.snackbar.openSnackBar({
						text: 'Unable to search PIN - Please Select an LRO',
						type: 'error',
					});
					friendlyError = 'Unable to search PIN - Please Select an LRO';
				} else
					friendlyError = this.teranetService.HandleError(
						'Unable to search PIN',
						err,
					);

				this.error = friendlyError;
				this.searchCompleted(false);
			} finally {
				this.searchingPins = false;
			}
		}
	}

	searchCompleted(value: boolean) {
		this.searchCompletedEvent.emit(value);
	}
}
